import { useState, useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { Entity } from '../models'

const GET_ACCOUNT_MANAGERS = gql`
  query GetAccountManagers {
    accountManagers {
      items {
        id
        name
      }
    }
  }
`


interface AccountManagersData {
  accountManagers: {
    items: Entity[]
  }
}

export const useAccountManagers = () => {
  const { loading, error, data } = useQuery<AccountManagersData>(GET_ACCOUNT_MANAGERS)

  const [results, setResults] = useState<Entity[]>([])

  useEffect(() => {
    setResults(data?.accountManagers.items || [])
  }, [data?.accountManagers.items, loading])

  return { loading, error, results }
}
